export enum EntityTypeCode {
  Operator = 'OPERATOR',
  Company = 'COMPANY',
  ThirsPartyService = 'THIRD_PARTY_SERVICE',
  Region = 'REGION',
  User = 'USER',
}
